import { lazy } from "react";
// data
import data from "src/config/search.json";
// pages
const GeoCodingPage = lazy(() => import("src/pages/geo-coding/geo-coding"));

const keys = Object.keys(data.services);
const currentkey = keys[5];

export const GeocodingRoutes = [
  {
    path: currentkey,
    children: [
      { path: data.services.Geocoding[0].url, element: <GeoCodingPage /> },
    ],
  },
];
